"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetDriveCompatibilityRequirementInstanceMetadataSchema = exports.NetDriveCompatibilityValidationResultKey = void 0;
const zod_1 = require("zod");
exports.NetDriveCompatibilityValidationResultKey = 'NetDriveCompatibilityResult';
exports.NetDriveCompatibilityRequirementInstanceMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal(exports.NetDriveCompatibilityValidationResultKey),
    netName: zod_1.z.string(),
    netStatsDepId: zod_1.z.string().optional(),
});
//# sourceMappingURL=NetDriveCompatibilityRequirementInstanceMetadata.js.map